import {ReactElement} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

interface DeleteIconProps {
    onClick: () => void;
    tooltip: string | ReactElement;
}

const DeleteIcon = ({onClick, tooltip}: DeleteIconProps): JSX.Element => (
    <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>} placement={'top'}>
        <i className="fs-1 fa-solid fa-trash cursor-pointer" onClick={onClick}></i>
    </OverlayTrigger>
);

export default DeleteIcon;
